import {Injectable}        from '@angular/core';
import {CampaignYearStore} from '../login/campaignyear.store';
import IField = Data.FieldManagement.IField;
import IFieldGeom = Data.FieldManagement.IFieldGeom;

@Injectable({
  providedIn: 'root'
})
export class ApGetGeomService {

  constructor(private campaignYearStore: CampaignYearStore) {
  }

  getGeom(field: IField): IFieldGeom {
    return field.FieldGeoms.Find((geom) =>
      geom.ValidFrom <= this.campaignYearStore.getSelectedCampaignYear().DefaultStart &&
      geom.ValidTo >= this.campaignYearStore.getSelectedCampaignYear().DefaultEnd);
  }
}
